import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Retorno } from '@app/models/retorno';
import { StorageService, AuthenticationService, GlobalService, PesquisaSatisfacaoService } from '@app/services';
import { MD5 } from 'crypto-js';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  token: string;
  auth: string;
  solicitacao: any;
  idSolicitacao: any;


  constructor(
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private pesquisaSatisfacaoService: PesquisaSatisfacaoService,
    private serviceStorage: StorageService,
  ) { 
    this.route.queryParams
      .subscribe((params) => {
        try {
          this.serviceStorage.cleanAccess();

          this.auth = params.auth;
          this.token = params.t;
          this.idSolicitacao = params.idSolicitacao;
          console.log("auth: constructor");
          console.log(this.auth);
          console.log(this.token);
          console.log(this.idSolicitacao);
          
          if (this.token) 
          {
            this.token = params.t.substring(10, (this.token.length - 10));
            this.serviceStorage.setAccess(
              {
                usuario: {},
                token: this.token,
              }
            );
          }
        }
        catch (error) {
          this.fecharJanelaErro("Acesso Negado!");
        }
      });
     
    
  }

  ngOnInit() 
  {
    this.spinner.show();
    this.pesquisaSatisfacaoService
    .getSolicitacaoPorId(this.idSolicitacao)
    .then((retorno:any) => 
    {
      if (retorno.sucesso == false)
      {
        this.spinner.hide();
        this.fecharJanelaErro(retorno.mensagem);
      }
      else
      {
        this.solicitacao = retorno.objeto;
        if (this.auth != this.getMD5(this.solicitacao.id,this.solicitacao.tituloAtendimento,this.solicitacao.numeroAtendimento)) 
        {
          this.fecharJanelaErro("Não foi possível localizar a experiência.");
        }
        else
        {
          this.pesquisaSatisfacaoService
            .getUsuario(this.solicitacao.matriculaAluno)
            .then((retorno:any) => 
            {
              if (retorno.sucesso == false)
              {
                this.spinner.hide();
                this.fecharJanelaErro(retorno.mensagem);
              }
              else
              {
                this.serviceStorage.setAccess(
                  {
                    usuario: retorno.objeto,
                    token: this.token,
                  }
                );
                //console.log(this.serviceStorage.getAccess());
                this.spinner.hide();
                this.router.navigateByUrl("/resposta?solicitacao=" + this.idSolicitacao);
              }
            });
        }
      }
    });

  }

  getMD5(idSolicitacao, tituloAtendimento, numeroAtendimento) {
    let retorno, concatenado, dataAtual;
    dataAtual = new Date();
    concatenado = idSolicitacao + tituloAtendimento + numeroAtendimento + dataAtual.getFullYear() + (dataAtual.getMonth() + 1) + dataAtual.getDate();
    retorno = MD5(concatenado);
    return retorno;
  }

  fecharJanelaErro(mensagem) {
    alert(mensagem);
    window.close();
  }

}
